/**
 * Brand identities the ProviderPill can render. Lives outside the component
 * file so fast refresh keeps working (see button-variants.ts for the same split).
 */
export const PILL_PROVIDERS = ["apple", "google", "stripe", "cpos"] as const;

export type PillProvider = (typeof PILL_PROVIDERS)[number];

/**
 * Narrows a free-form provider string onto the pills we can render.
 * Returns null for anything unrecognized so callers can fall back to raw text
 * rather than rendering an empty pill.
 */
export function toPillProvider(value: string | null): PillProvider | null {
  if (!value) return null;
  const key = value.toLowerCase();
  return PILL_PROVIDERS.find((p) => p === key) ?? null;
}
